$(function(){
  if($('.session-episodes').length){
    $('.session-episodes').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: true,
            arrows:true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                  dots: true
                }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
  }
   $('body').on('click', '.SessionPopup__close', function(e){
    e.preventDefault();
    $('.SessionPopup__overlay.leadform').removeClass('active');
  });

  $('body').on('click','.session-episode-imgbox',function(){
    
     if($('.SessionPopup__overlay.leadform').hasClass( "active" )){
        $('.session-popup-left iframe').attr('src',$(this).find('.episode-image').attr('data-src'));
        $('.session-popup-right .episode-name').html($(this).parents('.session-episode').find('.episode-name').html());
        $('.session-popup-right .episode-date').html($(this).parents('.session-episode').find('.episode-date').html());
        $('.SessionPopup__overlay.leadform').addClass('active');
     }else{
          $('.session-popup-left iframe').attr('src',$(this).find('.episode-image').attr('data-src'));
          $('.session-popup-right .episode-name').html($(this).parents('.session-episode').find('.episode-name').html());
          $('.session-popup-right .episode-date').html($(this).parents('.session-episode').find('.episode-date').html());
          $('.session-episodes-popup').html('');
       if($(this).parents('.session-episodes').find('.session-episode.slick-slide').length){
       
          $(this).parents('.session-episodes').find('.session-episode').not('.slick-cloned').each(function( index ) {
            $('.session-episodes-popup').append('<div class="session-episode">'+$( this ).html()+'</div>');
          });
         
           if($('.session-episodes-popup').hasClass('slick-initialized')) {
             $('.session-episodes-popup').slick('unslick');
           }
         
setTimeout(function () {
           $('.session-episodes-popup').slick({
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  dots: false,
                  arrows:true,
                  responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                  ]
          });
       }, 0);
         }
       
         $('.SessionPopup__overlay.leadform').addClass('active');  
       }
    
    });
});